import { ChallengeFilter, IChallenge, ISubmissionResult, SubmissionResult } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { decode } from 'html-entities';
import { defineStore } from 'pinia';
import { useApiClientStore } from './apiClientStore';
import { useCompetitionStore} from './competitionStore';

export const useChallengeStore = defineStore('challengeStore', 
{
    actions: 
    {
        async getRandomChallenge(category?: string, options?: {background?: boolean}): Promise<IChallenge|undefined>
        {
            const client = options?.background ? useApiClientStore().backgroundChallengeApiClient : useApiClientStore().challengeApiClient;

            const competitionId = useCompetitionStore().currentCompetition.id;
            const filter = new ChallengeFilter({
                competitionId,
                limit: 1,
                random: true,
                category,
                solvable: true
            })

            const page = await client.get(filter);

            let challenge: IChallenge = page.items[0];

            if (challenge)
            {
                challenge = await client.getOne(challenge.id);
                challenge.description = decode(challenge.description);
            }

            return challenge;
        },

        async submitResponse(challengeId: string, value: string|string[])
        {
            const client = useApiClientStore().challengeApiClient;

            return await client.putChallengeSubmission(challengeId, value);
        },

        async submitBotArtifactMessage(challengeId: string, message: string): Promise<string>
        {
            const client = useApiClientStore().challengeApiClient;
            const result = await client.putBotArtifactSubmission(challengeId, message);
            return result.explanation;
        }
    }
});
